<template>
  <div class="my-list">
    <div class="tabs">
      <div :class="'tab-item '+(status===''?'tab-item-active':'')" @click="changeStatus('')">全部</div>
      <div :class="'tab-item '+(status==='1'?'tab-item-active':'')"  @click="changeStatus('1')">提问成功</div>
      <div :class="'tab-item '+(status==='0'?'tab-item-active':'')"  @click="changeStatus('0')">审核中</div>
      <div :class="'tab-item '+(status==='2'?'tab-item-active':'')"  @click="changeStatus('2')">审核失败</div>
    </div>
    <!-- 15566931585 -->
    <div class="post-list" v-if="dataList&&dataList.length">
      <div class="post-info" v-for="item in dataList" :key="item.id">
        <div class="post-info-img" @click="routerHandle(item.id)">
          <img :src="item.userAvatarUrl" width="74px" height="74px" :alt="item.articleTitle"/>
        </div>
        <div class="post-detail" @click="routerHandle(item.id)">
          <div class="post-detail-title overell">{{item.articleTitle}}</div>
          <div class="post-detail-content">{{item.articleContent}}</div>
          <div class="post-detail-time">
            <span>提问时间：{{item.createTime}}</span>
          </div>
        </div>
        <div class="post-status">
          <div v-if="item.examined===1" class="post-status-success">提问成功</div>
          <div v-else-if="item.examined===0" class="post-status-ing">提问提交，审核中<br/>请耐心等待......</div>
          <div v-else class="post-status-fail">提问失败</div>
          <div class="post-status-evaluate" @click.stop="chooseRate(item)" v-if="!item.evaluated">评价</div>
          <div v-if="item.examined!==1" class="post-status-success-del" @click="deleteHandle(item)">删除</div>
        </div>
      </div>
    </div>
    <div v-else>
      <div style="text-align:center">
        <img :src="BASE_URL + 'img/kong.png'" alt="暂无数据">
      </div>
    </div>
    <div class="doclist-pagination" v-if="dataList&&dataList.length">
      <div class="doclist-lastpage" @click="jumpLastPage">上一页</div>
      <div class="doclist-omit">{{lastOmit}}</div>
      <ul>
        <li :class="item === currentPage?'pageactive':''" v-for="item in pageList" :key="item" @click="changePageTo(item)">{{item}}</li>
      </ul>
      <div class="doclist-omit">{{nextOmit}}</div>
      <div class="doclist-nextpage" @click="jumpNextPage">下一页</div>
      <div class="doclist-pagejump">共{{totalPage}}页，到第<input type="text" v-model.number="jumpTargetPage">页</div>
      <div class="doclist-jump" @click="jumpFarPage">确定</div>
    </div>
    <!-- 评分蒙版 -->
    <div class="rate-mask" v-if="isShowRate">
      <div class="rate-area">
          <div class="rate-text">
            <h3>请给出您的评价</h3>
            <div @click="handleRateCancel" class="rate-cancel-icon" src="">
            </div>
          </div>
          <div class="rate-block">
            <el-rate class="rate-choose" v-model="evaluateParams.expertScore"></el-rate>
          </div>
          <div class="rate-function">
            <div @click="handleRateCancel" class="rate-cancel">取消</div>
            <div @click="handleRate">提交</div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      BASE_URL: process.env.BASE_URL,
      status: '',
      dataList: [],
      isShowRate: false,
      evaluateParams: {
        expertId: '',
        expertScore: 0,
        articleId: ''
      },
      // 分页
      currentPage: 1, // 当前页
      totalPage: 4, // 总页数
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1 // 跳转页
    }
  },
  computed: {
    // 计算属性的 getter
  },
  mounted () {
    this.getDataList(this.currentPage)

    console.log(this.dataList)
  },
  methods: {
    // 上一页
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    //  下一页
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    //   第几页
    changePageTo (page) {
      this.getDataList(page)
    },
    //   确定跳转到哪页
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        this.changePageTo(this.jumpTargetPage)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    init () {
      this.$nextTick(() => {
        this.getDataList(1)
        // this.dataForm.companyId = ''
      })
    },
    getDataList (currentPage = this.currentPage) {
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/expertField/expertuserarticle/myArticle`, {
        'page': currentPage,
        'limit': 10,
        'examined': this.status === '' ? null : this.status
      })
        .then(({ data }) => {
          if (data && data.code === 0) {
            this.dataList = data.data.data || []
            this.totalPage = Math.ceil(Number(data.data.count) / 10)
          } else {
            this.dataList = []
            this.totalPage = 0
          }
          this.setPageTo(currentPage)
        })
        .catch(() => {
          this.dataList = []
          this.totalPage = 0
          this.setPageTo(currentPage)
        })
    },
    setPageTo (page) {
      if (this.totalPage === 0) {
        this.pageList = []
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = 0
        return
      } else if (page > this.totalPage) {
        this[this.status](this.totalPage)
        return
      }
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
    },
    changeStatus (index) {
      this.status = index
      this.getDataList(1)
    },
    routerHandle (id) {
      this.$router.push({
        name: 'postsDetail',
        query: {
          id: id
        }
      })
    },
    // 触发评价
    chooseRate (item) {
      this.isShowRate = true
      this.evaluateParams = {
        expertId: item.expertId,
        expertScore: 0,
        articleId: item.id
      }
    },
    // 清空评分数据
    handleRateCancel () {
      this.isShowRate = false
      this.evaluateParams = {
        expertId: '',
        expertScore: 0,
        articleId: ''
      }
    },
    // 评价
    handleRate () {
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/expertField/expertscore/save`, this.evaluateParams)
        .then(({ data }) => {
          if (data && data.code === 0) {
            this.$message.success('评价成功')
            this.handleRateCancel()
            this.getDataList()
          } else {
          }
        })
    },
    // 删除非审核通过的数据
    deleteHandle (item) {
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/expertField/expertuserarticle/deleteMyArticle`, {
        id: item.id
      })
        .then(({ data }) => {
          if (data && data.code === 0) {
            this.$message.success('删除成功')
            this.dataList = []
            this.totalPage = 0
            this.getDataList()
          } else {
          }
        })
        .catch(() => {
          // console.log(err)
        })
    }
  }
}
</script>
<style scoped lang="scss">
.my-list{
  margin: 0 79px;
}
.post-info{
  margin-top: 30px;
  width: 100%;
  display: flex;
  padding-bottom: 28px;
  border-bottom: 1px solid #eee;
}
.post-info-img{
  width: 74px;
  height: 74p;
  cursor: pointer;
}
.post-info-img img{
  width: 74px;
  height: 74p;
  border-radius: 37px;
  overflow: hidden;
}
.post-detail {
  cursor: pointer;
  width: 550px;
  margin-right: 20px;
  margin-left: 30px;
}
.post-detail-title{
  text-align: left;
  line-height: 22px;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0.6px;
  height: 22px;
  margin-bottom: 10px;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.post-detail-content{
  width: 500px;
  text-align: left;
  line-height: 20px;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0.6px;
  height: 20px;
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.post-detail-time{
  line-height: 17px;
  font-size: 12px;
  color: #666666;
  letter-spacing: 0.6px;
}
.post-status{
    width: 120px;
    text-align: center;
}
.post-status-success{
  text-align: center;
  line-height: 20px;
  font-size: 14px;
  color: #1D65A8;
  height: 20px;
}
.post-status-ing{
  text-align: left;
  line-height: 20px;
  font-size: 14px;
  color: #E2980A;
  width: 120px;
}
.post-status-fail{
  text-align: center;
  line-height: 20px;
  font-size: 14px;
  color: #BF1B22;
  height: 20px;
}
.post-status-evaluate{
  cursor: pointer;
}
.post-status-success-del{
  text-align: center;
  line-height: 20px;
  font-size: 14px;
  color: #1D65A8;
  height: 20px;
  cursor: pointer;
}
/* 评分蒙版样式 */
.rate-mask{
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  padding-top: 150px;
  top: 0;
  left: 0;
  z-index: 999;
}
.rate-area{
  width: 530px;
  height: 238px;
  background: white;
  display: flex;
  flex-direction: column;
  margin: 20px auto;
}
.rate-text{
  height: 54px;
  display: flex;
  color: #333333;
}
.rate-text h3{
  flex: 1;
  text-indent: 32px;
  line-height: 60px;
}
.rate-choose{
  padding-top: 16px;
  text-align: center;
  transform: scale(2)
}
.rate-cancel-icon{
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MDhGREUxQzhBQ0VDMTFFOUFEQTRFRDdENDk2MjI1OUUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MDhGREUxQzlBQ0VDMTFFOUFEQTRFRDdENDk2MjI1OUUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowOEZERTFDNkFDRUMxMUU5QURBNEVEN0Q0OTYyMjU5RSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowOEZERTFDN0FDRUMxMUU5QURBNEVEN0Q0OTYyMjU5RSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PmUCvhEAAADHSURBVHjanJIxDoQgEEVHTKxsqfAWnokD4AnYC+DpMFQWBgtr7Nn9JrvJskA2/oSG+S8zmfnkvSdjTAwhUIyx+uCBF0w7DEN0zpG1Vo/j+Oi6jnI6z5PmeY7rutJxHJpJKZsXTPu+XwUYShA6wQuG9X1PSqkLRiGFUwheMA1mLxnwn4OgD5iDoRz0A6YwlIMgRjf116hCCJqm6asrq23vve3cqVht5bVTNYhRaeW1aVrO+RWjEgQhhojjsiwa8LZtmu6G/CnAAHQQF6+gbr3XAAAAAElFTkSuQmCC) no-repeat 20px 20px;
  width: 54px;
  height: 54px;
  user-select: none;
  cursor: pointer;
}
.rate-block{
  flex: 1;
}
.rate-function{
  height: 50px;
  line-height: 50px;
  display: flex;
}
.rate-function div{
  box-sizing: border-box;
  width: 265px;
  height: 100%;
  text-align: center;
  user-select: none;
  cursor: pointer;
}
.rate-cancel{
  box-sizing: border-box;
  color: #1D65A8;
  border-top: 1px solid #1D65A8;
  border-right: 1px solid #1D65A8;
  border-bottom: 1px solid #1D65A8;
  border-left: 1px solid #1D65A8;
}
.rate-function div:nth-of-type(2){
  background: #1D65A8;
  color: white;
}
.tab-item-active {
  color: #1D65A8;
  border-bottom: 2px solid #1D65A8;
}
.tab-item {
  display: inline-block;
  /* padding: 12px 16px; */
  text-align: center;
  background: #FFFFFF;
  /* box-shadow: inset 0 -1px 0 0 #dddddd; */
  /* width: 88px; */
  height: 35px;
  line-height: 35px;
  font-size: 14px;
  letter-spacing: 0;
  margin-right: 24px;
  cursor: pointer;
}
</style>
